<template>
  <div id="wrapper-spinner" class="d-flex align-items-center justify-content-center" v-if="loading">
    <BeatLoader color="var(--main-azul)" />
  </div>
  <div v-else-if="exibir">

    <b-row>
        <b-col>
          <h4 class="mt-3">Dados do pedido de certidão <b-badge variant="secondary">n.º {{ certidao.id }}</b-badge></h4>
        </b-col>
        <b-col class="text-right">
          <p class="mt-3"><b>Data do pedido:</b> {{ certidao.created_at | formatar_data }}</p>
        </b-col>
    </b-row>

    <b-card>
      <b-card-text>
        <b-row>
          <b-col><b>Nome:</b> {{ certidao.nm_pesquisado }}</b-col>
          <b-col class="text-center"><b>Documento:</b> {{ certidao.nm_nr_cpfcnpj_certidao }}</b-col>
          <b-col class="text-center"><b>Status:</b> {{ certidao.status_nome }}</b-col>
          <b-col class="text-right"><b>Valor total:</b> Não informado</b-col>
        </b-row>
        <b-row>
          <b-col class="mt-3">
            <h5>Cartórios</h5>
            <ul class="list-group list-group-flush">
              <li class="list-group-item" v-for="cart in cartorios" :key="cart.cd_certidao_cartorio">
                <b-row>
                  <b-col class="col-6 pl-0">{{ cart.nome_cartorio }}</b-col>
                  <b-col class="text-center">{{ cart.comarca }}</b-col>
                  <b-col class="text-center">{{ cart.uf }}</b-col>
                  <b-col class="text-right pr-0">{{ cart.vl_certidao | money }}</b-col>
                </b-row>
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
import API from '../../services/api'

export default {
  props: ['numero'],
  components: {
    BeatLoader
  },
  data() {
    return {
      loading: false,
      exibir: false,
      certidao: {},
      cartorios: []
    }
  },
  methods: {
    async get_certidao(numero) {
      this.exibir = false
      this.loading = true
      const token = localStorage.getItem('jwtToken')
      const res = await API.get(`certidao/${numero}?token=${token}`)
      if(res.data.certidao) {
        this.loading = false
        this.certidao = res.data.certidao
        this.cartorios = res.data.cartorios
        this.exibir = true
      }
    }
  },
  mounted() {
    if(this.numero) this.get_certidao(this.numero)
  },
  watch: {
    numero(val) {
      this.get_certidao(val)
    }
  }
}
</script>

<style scoped>
#wrapper-spinner {
  width: 100%;
  height: 150px;
}
</style>
